import { css } from '@emotion/core';

export const iconGroupStyles = css`
  span,
  span > svg {
    width: 18px !important;
    height: 18px !important;
  }
`;
